// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M_opv","content":"styles_content__tFOnN"};